import { Button, Col, Form, Row } from "react-bootstrap";
import SendMessage from "./SendMessage";
import ReceivedMessage from "./ReceivedMessage";
import { ChatFileUploadIcon, SendMessageIcon } from "Assets/icons";
import { useEffect, useRef, useState } from "react";
import useSocket from "utils/socket/socket";
import { useGetChatQuery } from "store/services/chat";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { store } from "store/store";
import { useUploadFileMutation } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { NoRecordFound } from "components/Common/Common";

const ChatComponent = ({ caseLoadId }) => {

    const socket = useSocket();
    const state = store.getState();
    const user = state.auth.user;

    const [text, setText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [chat, setChat] = useState([]);
    const [socketLoading, setSocketLoading] = useState(false);

    const socketRef = useRef();
    const chatContainerRef = useRef();

    // chat api
    const { data, isLoading, isFetching } = useGetChatQuery({ caseloadId: caseLoadId, limit: pageSize, page: currentPage }, { skip: socketLoading });
    const [uploadFile, { isLoading: uploadFileLoading }] = useUploadFileMutation();

    const handleTextChange = (e) => {
        setText(e.target.value.trimLeft());
    };

    const handleSendMessage = ({ mediaUrl, messageType = "text" }) => {

        if (text || mediaUrl) {
            socketRef.current.emit("send_message", {
                caseloadId: caseLoadId,
                messageType,
                mediaUrl,
                message: text
            });

            setText("");
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    const handleReceiveMessage = (message) => {
        message?.caseloadId == caseLoadId && setChat(x => ([...x, message]));
    };

    const handleFileUpload = async (e) => {

        const file = e.target.files[0];
        if (!file) return;

        const response = await uploadFile({ file, acl: "public-read" });
        if (response?.error) return;

        handleSendMessage({ mediaUrl: response?.data, messageType: file.type });
    };

    const handleScroll = () => {
        if (chatContainerRef.current) {

            // Check if the user has scrolled to the top
            if (chatContainerRef.current.scrollTop === 0 && chat?.length >= currentPage * pageSize) {
                setCurrentPage(currentPage + 1)
            }
        }
    };

    useEffect(() => {

        // Socket Connection
        socket.connect();

        socket.on("connect", () => {
            console.log("Connected successfully!");
            socketRef.current = socket;
        });

        socket.on("connect_error", (err) => {
            console.error("Connection failed:", err);
        });

        socket.on("bad_request", (err) => {
            console.error("bad_request:", err);
        });

        socket.on("message_received", (message) => {
            handleReceiveMessage(message?.data)
        });

        socket.on("loading", ({ loading = false }) => {
            setSocketLoading(loading);
        });

        socket.on("disconnect", () => {
            console.error("Socket Disconnected!");
        });

        return () => socket.disconnect();

    }, []);

    useEffect(() => {
        if (data?.messages?.length) setChat(data?.messages?.concat(chat));
    }, [data]);

    useEffect(() => {
        if (chatContainerRef.current) chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;

    }, [chatContainerRef.current]);

    return (
        <section>
            {uploadFileLoading && <LoadingOverlay />}
            <Row>
                {/* <Col lg="12">
                    <div
                        className="py-2 px-3 d-flex align-items-center justify-content-between gap-10"
                        style={{ background: "#F3F3F3" }}
                    >
                        <h6 className="m-0 fw-sbold themeBlue">Chat</h6>
                    </div>
                </Col> */}
                    {/* <Col lg="12">
                        <div className="chatBody border common-border-radius mt-3">
                            <div className="chatMessageWrp p-4">
                                <ul onScroll={handleScroll} ref={chatContainerRef} style={{ height: "30vh", overflowY: "auto" }} className="list-unstyled ps-0 mb-0">
                                    {
                                        socketLoading || isLoading ? <LoadingIndicator /> : !chat?.length ? <NoRecordFound /> : chat?.map((item, index) => {
                                            return item?.sender?.userId == user?.id ? (
                                                <SendMessage messageDetails={item} />
                                            ) : (<ReceivedMessage messageDetails={item} />)
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="chatFooter p-2 px-3 border-top">
                                <Form onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSendMessage({});
                                }}>
                                    <div className="d-flex align-items-center gap-10">
                                        <label
                                            className="border-0 p-0"
                                            variant="transparent"
                                            type="button"
                                            htmlFor="chat-file-upload"
                                        >
                                            <ChatFileUploadIcon />
                                        </label>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            id="chat-file-upload"
                                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            onChange={handleFileUpload}
                                            disabled={socketLoading}
                                        />
                                        <div className="iconWithText position-relative w-100">
                                            <Button
                                                type="submit"
                                                className="border-0 p-0 position-absolute icn"
                                                variant="transparent"
                                                style={{ right: 10 }}
                                                onClick={handleSendMessage}
                                                disabled={!text || socketLoading}
                                            >
                                                <SendMessageIcon />
                                            </Button>
                                            <input
                                                type="text"
                                                className="form-control bg-white"
                                                onChange={handleTextChange}
                                                value={text}
                                                disabled={socketLoading}
                                            />
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </Col> */}
                {/* <Col lg="12" className="my-3">
                    <div className={`chatWrpper`}>
                        <div
                            className="p-2 d-flex align-itmes-center justify-content-between gap-10"
                            style={{ background: "#F3F3F3" }}
                        >
                            <h6 className="m-0 fw-sbold themeBlue">Chat</h6>
                            <Button
                                style={{
                                    background: "#071E3E",
                                    borderColor: "#071E3E",
                                    fontSize: 14,
                                }}
                                className="d-flex align-items-center justify-content-center rounded-pill"
                            >
                                Resolve
                            </Button>
                        </div>
                        <div className="chatBody border rounded mt-3">
                            <div className="chatMessageWrp p-2 px-3">
                                <ul className="list-unstyled ps-0 mb-0">
                                    <li className="py-1">
                                        <div className="d-flex align-items-start gap-10">
                                            <div className="imgWrp flex-shrink-0">
                                                <img
                                                    src={p1}
                                                    alt=""
                                                    className="img-fluid rounded-circle object-fit-cover"
                                                    style={{ height: 40, width: 40 }}
                                                />
                                            </div>
                                            <div
                                                className="content w-100 p-2 px-3 rounded"
                                                style={{
                                                    maxWidth: "max-content",
                                                    background: "#B46C9F",
                                                }}
                                            >
                                                <h6 className="m-0 pb-1 text-white">
                                                    Jesmine (SLP)
                                                </h6>
                                                <p className="m-0 text-white">
                                                    this child needs an OT to look at
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="py-1">
                                        <div className="d-flex align-items-start justify-content-end gap-10">
                                            <div
                                                className="content w-100 p-2 px-3 rounded"
                                                style={{
                                                    maxWidth: "max-content",
                                                    background: "#3DA0AA",
                                                }}
                                            >
                                                <p className="m-0 text-white">Okay. Noted!</p>
                                            </div>
                                            <div className="imgWrp flex-shrink-0">
                                                <img
                                                    src={p1}
                                                    alt=""
                                                    className="img-fluid rounded-circle object-fit-cover"
                                                    style={{ height: 40, width: 40 }}
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li className="py-1">
                                        <div className="d-flex align-items-start gap-10">
                                            <div className="imgWrp flex-shrink-0">
                                                <img
                                                    src={p1}
                                                    alt=""
                                                    className="img-fluid rounded-circle object-fit-cover"
                                                    style={{ height: 40, width: 40 }}
                                                />
                                            </div>
                                            <div
                                                className="content w-100 p-2 px-3 rounded"
                                                style={{
                                                    maxWidth: "max-content",
                                                    background: "#B46C9F",
                                                }}
                                            >
                                                <h6 className="m-0 pb-1 text-white">
                                                    Jesmine (SLP)
                                                </h6>
                                                <p className="m-0 text-white">
                                                    omg, this is amazing
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="py-1">
                                        <div className="d-flex align-items-start justify-content-end gap-10">
                                            <div
                                                className="content w-100 p-2 px-3 rounded"
                                                style={{
                                                    maxWidth: "max-content",
                                                    background: "#3DA0AA",
                                                }}
                                            >
                                                <p className="m-0 text-white">woohoooo</p>
                                            </div>
                                            <div className="imgWrp flex-shrink-0">
                                                <img
                                                    src={p1}
                                                    alt=""
                                                    className="img-fluid rounded-circle object-fit-cover"
                                                    style={{ height: 40, width: 40 }}
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="chatFooter p-2 px-3 border-top">
                                <Form>
                                    <div className="d-flex align-items-center gap-10">
                                        <Button
                                            className="border-0 p-0"
                                            variant="transparent"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="20"
                                                viewBox="0 0 18 20"
                                                fill="none"
                                            >
                                                <path
                                                    opacity="0.4"
                                                    d="M6.1875 20C2.82812 20 0.09375 17.2656 0.09375 13.8672C0.09375 12.2266 0.71875 10.6641 1.85156 9.53125L10.0938 1.28906C10.9531 0.46875 12.1641 0 13.3359 0C16.2656 0 17.9062 2.38281 17.9062 4.53125C17.9062 5.74219 17.3984 6.91406 16.5391 7.77344L9 15.3125C8.41406 15.8984 7.63281 16.1719 6.89062 16.1719C4.50781 16.1719 3.88281 14.0625 3.88281 13.2031C3.88281 12.4609 4.19531 11.6797 4.78125 11.0938L10.3281 5.54688C10.5625 5.3125 10.8359 5.23438 11.1094 5.23438C11.6953 5.23438 12.2031 5.70312 12.2031 6.32812C12.2031 6.60156 12.0859 6.875 11.8906 7.10938L6.30469 12.6562C6.14844 12.8125 6.07031 13.0078 6.07031 13.2031C6.07031 13.6719 6.46094 14.0234 6.89062 14.0234C7.08594 14.0234 7.28125 13.9453 7.4375 13.7891L15.0156 6.21094C15.4453 5.74219 15.6797 5.15625 15.6797 4.53125C15.6797 3.4375 14.8594 2.1875 13.3359 2.1875C12.7109 2.1875 12.0859 2.42188 11.6562 2.85156L3.41406 11.0938C2.67188 11.8359 2.28125 12.8125 2.28125 13.8672C2.28125 15.7422 3.64844 17.7734 6.1875 17.7734C7.24219 17.7734 8.25781 17.4219 9 16.6797L15.2109 10.4297C15.4453 10.2344 15.7188 10.1172 15.9922 10.1172C16.5781 10.1172 17.0859 10.5859 17.0859 11.2109C17.0859 11.4844 16.9688 11.7578 16.7734 11.9922L10.5234 18.2031C9.39062 19.375 7.82812 20 6.1875 20Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </Button>
                                        <div className="iconWithText position-relative w-100">
                                            <Button
                                                className="border-0 p-0 position-absolute icn"
                                                variant="transparent"
                                                style={{ right: 10 }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="21"
                                                    viewBox="0 0 22 21"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M20.9609 2.44531L18.4609 18.6562C18.4219 19.0469 18.1875 19.3984 17.8359 19.5938C17.6406 19.6719 17.4453 19.75 17.2109 19.75C17.0547 19.75 16.8984 19.7109 16.7422 19.6328L11.9766 17.6406L9.98438 20.6094C9.82812 20.8828 9.55469 21 9.28125 21C8.85156 21 8.5 20.6484 8.5 20.2188V16.4688C8.5 16.1562 8.57812 15.8828 8.73438 15.6875L17.25 4.75L5.76562 15.1016L1.74219 13.4219C1.3125 13.2266 1 12.8359 1 12.3281C0.960938 11.7812 1.19531 11.3906 1.625 11.1562L19.125 1.19531C19.5156 0.960938 20.0625 0.960938 20.4531 1.23438C20.8438 1.50781 21.0391 1.97656 20.9609 2.44531Z"
                                                        fill="#B46C9F"
                                                    />
                                                </svg>
                                            </Button>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Col> */}
            </Row>
        </section>
    )
};

export default ChatComponent;